import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Author } from '@interfaces/authors';
import { ContentType } from '@tracking';

interface ArticleProps {
  className?: string;
  children: React.ReactNode;
  articleId: number;
  articleAuthors: Author[];
  contentIndex?: number;
}

const ArticleFeedItem = ({
  children,
  className,
  contentIndex,
  articleId,
  articleAuthors = [],
}: ArticleProps) => {
  const { Track } = useEventTracking({
    contentType: ContentType.Article,
    contentId: articleId,
    creatorIds: articleAuthors.map((author) => author.id),
    contentIndex: contentIndex,
  });

  return (
    <Track>
      <article className={clsx(className, 'flex')}>{children}</article>
    </Track>
  );
};

export default ArticleFeedItem;
